import React from 'react';

import AppDispatcher from './../dispatcher/AppDispatcher';
import AppConstants from './../constants/AppConstants';


const MenuButton = React.createClass({
  /**
   * Used by React as the component name
   */
  displayName: 'MenuButton',


  /**
   * Start scroll position of the buttonWrapperEl prop
   */
  touchStartPos: 0,


  /**
   * End scroll position of the buttonWrapperEl prop
   */
  touchEndPos: 0,


  /**
   * Expected propTypes
   * @prop {ReactElement} buttonWrapperEl - The button wrapper element
   * @prop {Function} clickHandler - The click handler for the button
   * @prop {Number} currentSlide - The iteration of the current section
   * @prop {Object} data - A data object
   * @prop {Number} iteration - The iteration of the button
   * @prop {Boolean} large - If the user is viewing the large experience
   * @prop {Boolean} touch - If browser supports touch events
   */
  propTypes: {
    buttonWrapperEl: React.PropTypes.object,
    clickHandler: React.PropTypes.func,
    currentSlide: React.PropTypes.number,
    data: React.PropTypes.object.isRequired,
    iteration: React.PropTypes.number.isRequired,
    large: React.PropTypes.bool.isRequired,
    touch: React.PropTypes.bool,
  },


  /**
   * Get initial state object
   * @returns {Object} initial state
   */
  getInitialState() {
    return {
      dragging: false,
    };
  },


  /**
   * Renders component
   * @returns {Object} React element
   */
  render() {
    const data = this.props.data;
    const touchStartHandler = this.props.touch ? this._onTouchStart : null;
    let touchEndHandler = this.props.touch ? this._onTouchEnd : null;
    if (this.props.large && this.props.touch) {
      touchEndHandler = this._onClick;
    }
    const clickHandler = !this.props.touch ? this._onClick : null;
    const compareNumber = this.props.large ?
      (this.props.currentSlide + 3) : (this.props.currentSlide + 1);
    let title = data.title;
    let emojis;
    const selectedClass = (data.sortOrder === compareNumber) ? ' active' : '';
    const className = 'component-menu-button' + selectedClass;

    if (data.type === 'landing') {
      title = 'Home';
    }

    if (data.type === 'gif') {
      emojis = this._renderEmojis();
    }

    return (
      <li
        onTouchStart={touchStartHandler}
        onTouchEnd={touchEndHandler}
        onClick={clickHandler}
        className={className}
      >
        {title} {emojis}
      </li>
    );
  },


  /**
   * Renders emojis
   * @returns {Array<ReactElement>} An array of ReactElements
   */
  _renderEmojis() {
    const data = this.props.data;
    const emojis = [];

    for (let i = 0; i < data.emojis.length; i++) {
      const key = 'main-menu-button-' + data.id + '-emoji-' + i;

      emojis.push(
        <span key={key} className='emoji'>{data.emojis[i].character}</span>
      );
    }

    return emojis;
  },

  /**
   * TouchStart handler
   * @returns {Object} React element
   */
  _onTouchStart() {
    this.touchStartPos = this.props.buttonWrapperEl.scrollTop;
  },


  /**
   * TouchEnd handler
   * @returns {Object} React element
   */
  _onTouchEnd() {
    this.touchEndPos = this.props.buttonWrapperEl.scrollTop;

    let dif = this.touchStartPos - this.touchEndPos;
    if (dif < 0) {
      dif *= -1;
    }

    if (dif <= 1) {
      AppDispatcher.handleViewAction({
        actionType: AppConstants.CLOSE_MAIN_MENU,
      });

      AppDispatcher.handleViewAction({
        actionType: AppConstants.GO_TO_SLIDE,
        slide: this.props.iteration,
      });
    }
  },

  /**
   * Click handler
   * @returns {Object} React element
   */
  _onClick() {
    AppDispatcher.handleViewAction({
      actionType: AppConstants.CLOSE_MAIN_MENU,
    });

    AppDispatcher.handleViewAction({
      actionType: AppConstants.GO_TO_SLIDE,
      slide: this.props.iteration,
    });
  },
});

export default MenuButton;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/MenuButton.jsx
 **/